import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { Loader2 } from 'lucide-react';
import { auth } from '@/lib/firebase';
import LandingPage from '@/pages/LandingPage';
import { homePathForCurrentUser } from '@/hooks/useUserRoles';

/** Landing page for guests only; signed-in users go to Home (or /reviewer). */
const PublicLandingRoute: React.FC = () => {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [nextPath, setNextPath] = useState('/home');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
      if (!user) {
        setChecking(false);
        return;
      }
      void homePathForCurrentUser().then((path) => {
        setNextPath(path);
        setChecking(false);
      });
    });
    return unsub;
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-index-accent" />
      </div>
    );
  }

  if (authenticated) {
    return <Navigate to={nextPath} replace />;
  }

  return <LandingPage />;
};

export default PublicLandingRoute;
